'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorDisabled = void 0;
var $ = require("jquery");
var AnchorDisabled = /** @class */ (function () {
    function AnchorDisabled() {
        this.key = '.bulletAnchorDisabled';
        if ($(this.key).length > 0) {
            for (var i = 0; i < $(this.key).length; i++) {
                var anchor = $(this.key).eq(i);
                anchor.addClass('anchor-disabled');
            }
        }
        $(this.key).click(function (e) {
            e.preventDefault();
        });
    }
    return AnchorDisabled;
}());
exports.AnchorDisabled = AnchorDisabled;
exports.default = AnchorDisabled;
